module.exports = __webpack_public_path__ + "img/completed-stamp.20dea267.svg";